<template>
  <div class="ui form">
    <!-- <div class="ui four item top attached tabular menu" ref="tabsss">
      <a class="active item" data-tab="setup">
        <i class="cog icon"></i> {{ $t("setup") }}</a
      >
      <a class="item" data-tab="query">
        <i class="search icon"></i> {{ $t("query") }}</a
      >
      <a class="item" data-tab="pay">
        <i class="credit card icon"></i> {{ $t("pay") }}</a
      >
      <a class="item" data-tab="reverse">
        <i class="undo icon"></i> {{ $t("reverse") }}</a
      >
    </div> -->
    <!-- <div class="ui bottom attached active tab segment" data-tab="setup"> -->
    <setup
      :setting="setting"
      :index="index"
      ref="setup"
      @remove="remove_setting"
      :integration_files="integration_files"
    />
    <!-- </div>
    <div class="ui bottom attached tab segment" data-tab="query">
      <query :setting="setting" ref="query" />
    </div>
    <div class="ui bottom attached tab segment" data-tab="pay">
      Pay
    </div>
    <div class="ui bottom attached tab segment" data-tab="reverse">
      Reverse
    </div> -->
  </div>
</template>

<script>
import Setup from "./Setup";
// import Query from "./Query";

export default {
  name: "",
  props: { setting: Object, index: Number, integration_files: Array },
  components: { Setup /* Query */ },
  data() {
    return {};
  },
  methods: {
    remove_setting(idx) {
      this.$emit("remove", idx);
    },
    init_tabs() {
      let vm = this;

      window
        .jQuery(vm.$refs.tabsss)
        .find(".item")
        .tab();
      vm.$refs.setup.init_tabs();
    },
  },
  mounted() {},
};
</script>
